<ng-container *transloco="let t">
    <!-- <us-breadcrumbs
        *ngrxLet="homePageUrl$ as homePageUrl"
        [items]="[
            { title: t('home'),routerLink: homePageUrl },
            { title: t('orders_list') }
        ]"
    >
    </us-breadcrumbs> -->

    <ng-container *ngIf="loading$ | async; else ordersTemplate">
        <div class="flex flex-col gap-4">
            <div role="status" class="max-w-sm animate-pulse" *ngFor="let item of [1,2,3,4,5]">
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-2.5"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[330px] mb-2.5"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[300px] mb-2.5"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"></div>
                <span class="sr-only">{{t('loading')}}...</span>
            </div>
        </div>
    </ng-container>

    <ng-template #ordersTemplate>
        <ng-container *ngIf="(orders$ | async)?.length! > 0; else emptyTemplate">
            <div class="flex flex-col gap-2">
                <us-order-list-item
                    *ngFor="let order of orders$ | async; let i = index"
                    [order]="order"
                ></us-order-list-item>
            </div>
        </ng-container>
    </ng-template>

    <ng-template #emptyTemplate>
        <us-empty [title]="t('you_do_not_have_any_orders_yet')"></us-empty>
    </ng-template>
</ng-container>
